import React from "react";
import ListSVG from "assets/icons/list.inline.svg";

import Icon from "./Icon";

const List = ({ ...rest }) => (
  <Icon name="list" alt="List" {...rest}>
    <ListSVG />
  </Icon>
);

export default List;
